<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ item }} -->
    <b-card class="border-none py-0 mb-0 px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="mr-1"></i>
        {{ item.passenger }}
      </b-card-header>
      <b-card-body class="py-0">
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Event" label-size="sm">
              <treeselect
                placeholder="Select event..."
                v-model="item.eventcode"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadEvent"
                searchPromptText="Type at least 4 chars..."
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                :disabled="true"
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
              <treeselect
                placeholder="Select slac..."
                searchPromptText="Type at least 3 chars..."
                v-model="item.slac"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadSLAC"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                :disabled="true"
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Passenger" label-size="sm">
              <b-input-group>
                <b-form-input
                  v-model="item.passenger"
                  :debounce="options.debounce"
                  placeholder="Passenger"
                  :disabled="true"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="true"
                    @click="item.passenger = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- {{item}} -->
        <div>
          <b-row class="px-0 mt-0">
            <!-- <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Date Travel"
                label-for="datetravel"
                label-cols="12"
              >
                <b-input-group>
                  <treeselect
                    instanceId="datetravel"
                    type="number"
                    v-model="datetravel"
                    :clearable="true"
                    :options="datetravel_options"
                  ></treeselect>
                </b-input-group>
              </b-form-group>
            </b-col> -->
            <b-col cols="auto">
              <b-button-group class="ml-0 mt-3">
                <b-row no-gutters>
                  <b-col cols="auto">
                    <b-button
                      squared
                      size="sm"
                      :variant="toolbar_variant"
                      :pressed="active == 'flights' ? true : false"
                      @click="changeview('flights')"
                    >
                      <i class="fa fa-plane pr-3"></i>Flights
                    </b-button></b-col
                  >
                  <b-col cols="auto">
                    <b-button
                      squared
                      size="sm"
                      :variant="toolbar_variant"
                      :pressed="active == 'cars' ? true : false"
                      @click="changeview('cars')"
                    >
                      <i class="fa fa-car pr-3"></i>Cars
                    </b-button></b-col
                  >
                  <b-col cols="auto">
                    <b-button
                      squared
                      size="sm"
                      :variant="toolbar_variant"
                      :pressed="active == 'hotels' ? true : false"
                      @click="changeview('hotels')"
                    >
                      <i class="fa fa-bed pr-3"></i>Hotels
                    </b-button></b-col
                  >
                </b-row>
              </b-button-group>
            </b-col>
            <b-col class="text-right">
              <!-- {{activedate}} -->
              <b-form-radio-group
                v-model="activedate"
                :options="datetravel_options"
                buttons
                button-variant="outline-success"
                size="sm"
                name="radio-btn-outline"
                class="ml-0 mt-3"
              ></b-form-radio-group>

            </b-col>
          </b-row>
        </div>
        <div>
          <b-overlay
            :show="options.overlay_show"
            opacity=".9"
            v-click-outside="outside"
          >
            <div class="availtable datatable nested">
              <b-table
                :dark="$store.state.darkMode"
                ref="btable"
                sticky-header="350px"
                striped
                hover
                small
                caption-bottom
                show-empty
                :busy="busy"
                :items="items"
                :fields="options['fields_' + active]"
                :filter="find"
                @row-clicked="rowClicked"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)>
                  <i :class="options.icon" class="text-primary"></i>
                </template>
                <template v-slot:cell(departure)="slot">
                  {{ slot.item.departure }}
                  {{ slot.item.deptime}}
                </template>

                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        $helpers.badgeField(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in $helpers.actionsValid(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="table_action(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="action.icon"
                                  class="text-primary"
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in $helpers.actionsValid(row.item, options)"
                      :key="action.key"
                      @click.stop="table_action(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="action.icon" class="text-primary"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details="row">
                  <b-card>
                    <component
                      :is="options.component.name"
                      :search="search"
                      @discard="discard(row)"
                    ></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? dispatcher(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
          <b-row class="excelsheetbuttons px-1 mb-3">
            <b-col>
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin"></i>
                <span class="ml-1">Updating ...</span>
              </div>
              <span v-if="!busy">Found {{ items.length }} rows</span>
            </b-col>

            <b-col class="text-right">
              <b-link
                id="pnr-excel"
                class="mt-1 excel"
                @click="$helpers.outputExcel({ items })"
                title="Send to excel"
              >
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="pnr-excel" triggers="hover"
                >Grid to excel</b-tooltip
              >
            </b-col>
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer class="my-2">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span class="text-primary">{{ message }}</span>
            </div>
          </b-col>
          <b-col cols="8" class="text-right">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
            <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";


export default {
  name: "PNRData",
  watch: {
    activedate: {
      handler(newVal, oldVal) {
        if (newVal) {
          console.log("watch:activedate", newVal);
          this.itineraryday = this.item.itinerary.find((o) => o.datetravel == newVal)
          this.changeview("flights");
        }
      },
    },
  },
  data() {
    return {
      toolbar_variant: "outline-primary",
      busy: false,
      message: "",
      find: null,
      id: null,
      datetravel_options: [],
      items: [],
      item: {},
      active: "flights",
      activedate: null,
      itineraryday: { flights: [], cars: [], hotels: [] },
      options: {
        title: "Itinerary Data",
        icon: "fa fa-suitcase text-primary",
      },
    };
  },
  methods: {
    async load() {
      this.busy = true;

      let variables = {
        id: this.idselected,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query itineraries($id: String) {
              itineraries(id: $id) {
                id
                eventcode
                slac
                passenger
                days
                itinerary {
                  datetravel
                  flights {
                    ticketno
                    flightno
                    depDate: departuredate
                    depAirport: departureairport
                    depTer: departureterminal
                    arrAirport: arrivalairport
                    arrDate: arrivaldate
                    arrTer: arrivalterminal
                    classname
                    bags
                    duration
                    aircraft
                  }
                }
              }
            }
          `,
          variables,
        });

        if (response.data.itineraries.length > 0) {
          this.item = response.data.itineraries[0];
          // this.item.datereceived = this.$moment
          //   .unix(this.item.datereceived / 1000)
          //   .utc()
          //   .format("YYYY-MM-DD HH:mm:ss");
          this.datetravel_options = [];
          for (var k = 0; k < this.item.itinerary.length; k++) {
            this.datetravel_options.push({
              value: this.item.itinerary[k].datetravel,
              text: this.$moment(this.item.itinerary[k].datetravel).format(
                "ddd DD/MM"
              ),
            });
          }
          this.activedate = this.item.itinerary[0].datetravel;
          this.itineraryday = this.item.itinerary[0];
          this.changeview("flights");
        }

        // this.items = response.data.itineraries;

        console.log(this.items);
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    changeview(a) {
      this.items = []
      this.active = a;
      this.items = [...this.itineraryday[this.active]];
      this.items.forEach(function (v) {
        delete v.__typename;
      });
    },
    rowClicked() {},
    discard() {
      this.$emit("discard", null);
    },
    outside() {},
  },
};
</script>

<style>
</style>